/* eslint-disable max-len */
import {getPrismProgram} from '../../shared/helpers/common'

const createDescriptionObject = (point) => {
  return {
    subdescription: [''],
    points: [point]
  }
}
const prismProgram = getPrismProgram()
const easiLink = '<a href="https://www.easidemographics.com/web/" target="_blank">www.easidemographics.com/web</a>'
const cdcLink =
  '<a href="https://www.atsdr.cdc.gov/placeandhealth/svi/index.html" target="_blank">www.atsdr.cdc.gov/placeandhealth/svi/index.html</a>'
const climateHazardsLink = '<a href="https://hazards.fema.gov/nri/" target="_blank">https://hazards.fema.gov/nri/</a>'
const militaryLink = '<a href="https://www.militaryonesource.mil/" target="_blank">www.militaryonesource.mil</a>'
const unitedStatesLink = '<a href="https://www.census.gov/" target="_blank">https://www.census.gov/</a>'
const cdcPlacesLink =
  '<a href="https://www.cdc.gov/places/index.html" target="_blank">https://www.cdc.gov/places/index.html</a>'
export const faqData = {
  [`${prismProgram} Data`]: {
    Content: [
      {
        id: 0,
        expanded: false,
        title: 'Available Data',
        question: `What data is available in ${prismProgram}?`,
        description: [
          `${prismProgram} contains one of the largest community factors datasets in the U.S. At its core, it's a demographic dataset and the premier source for detailed U.S. population information. There is a broad range of data available in ${prismProgram}, such as the household U.S. address, household income, household debt, dwelling type, veteran status, etc. We also have data on individual and household level lifestyle and behavior data such as, interest in low fat cooking, prescription adherence, etc. Additionally, data from ${prismProgram}'s state-of-the-art models, such as disease likelihood and transportation insecurity, are available to help you understand your communities.`
        ]
      },
      {
        id: 1,

        expanded: false,
        title: 'Data Structure and Storage',
        question: `How is ${prismProgram} data structured and stored?`,
        description: [
          'The data is stored using Google Big Query, a cloud-based data warehouse that organizes information into tables with rows and columns. Each row corresponds to information related to an individual, while nearly 1,500 columns represent their individual and household level characteristics. Each person is represented by a unique identifier or ID, with individuals in a household represented by a common household ID. Additionally, each address in the dataset is represented by a unique address ID.'
        ]
      },
      {
        id: 2,
        expanded: false,
        title: 'Data Update Cadence',
        question: `How often is ${prismProgram} data updated?`,
        description: [
          `${prismProgram} data is typically updated about once every two months. However, it is important to note that the specific update schedule may be subject to change depending on various factors, such as changes in data sources or updates to the ${prismProgram} platform itself. Additionally, some data within ${prismProgram} may be updated more frequently than others, depending on factors such as the source and type of data.`
        ]
      },
      {
        id: 3,
        expanded: false,
        title: 'Data Sources',
        question: `Where does the data in ${prismProgram} come from?`,
        description: [
          {
            subdescription: ['Internal data sources:'],
            points: [
              'Vendor provided data, including individual level features such as demographic, socioeconomic, lifestyle and behavioral data, available for ~95% of the US adult population.',
              'Modeled outputs such as disease indicators and other individual and household level processed features, available for ~95% of the US adult population.'
            ]
          },
          {
            subdescription: ['External data sources:'],
            points: [
              `United States Census Bureau (${unitedStatesLink})`,
              `EASI Master Database (${easiLink})`,
              `CDC Places Dataset (CDC’s BRFSS based census tract level estimates - ${cdcPlacesLink})`,
              `CDC Social Vulnerability Index 2018 Estimates (${cdcLink})`,
              `Climate Hazards and National Risk Index (${climateHazardsLink})`,
              `Military OneSource (Military demographic distribution across age, race, and gender at state level - ${militaryLink})`,
              `Medicaid and commercial healthcare data`
            ]
          }
        ]
      },

      {
        id: 4,
        expanded: false,
        title: 'Data Granularity',
        question: `At what levels of granularity can you view ${prismProgram} data?`,
        description: [
          {
            subdescription: [
              `You can view ${prismProgram} data at the country, state, county, census tract, zip code, census block, and household levels.`
            ],
            points: []
          },
          {
            subdescription: [''],
            points: [
              '<b>Census Tract:</b> A small geographic area defined by the U.S. Census Bureau. Census tract Geo IDs are numeric codes that uniquely identify these administrative and statistical geographic areas.',
              '<b>Zip Code:</b> Data summarized by zip code for the selected state or states.',
              '<b>Census Block:</b> A very small geographic area defined by the U.S. Census Bureau, typically smaller than a census tract.',
              '<b>Household:</b> The most detailed level available, showing distinct household/address-level data in the dataset for more granular analysis and exploration of target populations.'
            ]
          }
        ]
      },
      {
        id: 5,
        expanded: false,
        title: 'Duplicate Records',
        question: `Does ${prismProgram} combine duplicate records from different data sources? `,
        description: [
          `No, ${prismProgram} does not combine data. The ${prismProgram} team does its best to reduce duplicate records for individuals using a combination of name and address matching and validation across current and historic records. However, there may still be a few individuals who may be represented more than once in the dataset, especially in the case where they may have multiple homes. For more information on data sources that feed into ${prismProgram}, see`
        ]
      },
      {
        id: 6,
        expanded: false,
        title: 'Points of Interest (POIs)',
        question: `What Points of Interest (POIs) are accessible in ${prismProgram} and where does this information come from?`,
        description: [
          `The points of interest that you can access in the ${prismProgram} web application include hospitals, urgent care facilities, pharmacies, child care facilities, OBGYNs, mental health facilities, grocery stores, and Federally Qualified Health Centers and Service Sites. In general, POI data is typically sourced from a combination of public and private data sources, including government records, business directories, and user-generated content. Some examples of sources for POI data may include social media platforms, mapping services, and commercial data providers.`
        ]
      },
      {
        id: 7,
        expanded: false,
        title: 'Matching Census Distributions',
        question: `At what level does ${prismProgram} data match 2020 US Census distributions for age, race, and gender?`,
        description: [
          `${prismProgram} data matches 2020 Census distributions at the county level. For more information on data sources that feed into ${prismProgram}, see `
        ]
      },
      {
        id: 8,
        expanded: false,
        title: 'Data on Children',
        question: `Does ${prismProgram} include data on children?`,
        description: [
          `${prismProgram} does contain information on children, but this data is only available at the household level, and not at the individual child level.`
        ]
      }
    ]
  },

  [`${prismProgram} Models`]: {
    Content: [
      {
        id: 9,
        expanded: false,
        title: 'Available Models',
        question: `What models does ${prismProgram} contain? `,
        description: [
          {
            subdescription: [
              `${prismProgram} contains various predictive analytics models across numerous use cases, to help you understand at-risk populations. Some examples include:`
            ],
            points: []
          },
          createDescriptionObject('Disease risk models (e.g. Diabetes, Opioid misuse, Depression etc.)'),
          createDescriptionObject('Uninsured risk'),
          createDescriptionObject('Eviction risk'),
          createDescriptionObject('Transportation insecurity'),
          createDescriptionObject('Food insecurity'),
          createDescriptionObject('SNAP eligibility'),
          createDescriptionObject('Medicaid eligibility'),
          createDescriptionObject('Active-duty military'),
          createDescriptionObject('Unemployment risk')
        ]
      },
      {
        id: 10,
        expanded: false,
        title: 'Model Development & Validation',
        question: `How are ${prismProgram} models developed and validated?`,
        description: [
          {
            subdescription: [
              `First, we build a complete picture by combining ${prismProgram} information with other public and commercial data. We carefully ensure this dataset reflects the diversity of the U.S. population across age, race, gender, income, and location.`
            ],
            points: []
          },
          {
            subdescription: [
              'Next, we use this data to train our predictive models and then test them on unseen data to confirm their accuracy. We build "explainable" models so we can be transparent about how they work, and we rigorously check for any bias to ensure fairness.'
            ],
            points: []
          },
          {
            subdescription: [
              `Finally, the best model is used to generate health risk scores for the entire ${prismProgram} population. To guarantee our insights are reliable, we validate these scores against established ground-truth data from public health agencies like the CDC.`
            ],
            points: []
          }
        ]
      },
      {
        id: 11,
        expanded: false,
        title: 'Model Accuracy',
        question: `What is the accuracy of ${prismProgram} models?`,
        description: [
          `All our ${prismProgram} models are proven to be highly reliable, achieving over 85% accuracy in rigorous testing.`
        ]
      }
    ]
  },

  'Term Definitions': {
    Content: [
      {
        id: 12,
        expanded: false,
        title: 'Households & Population',
        question: 'What is the difference between households and population? ',
        description: [
          `Households are the number of U.S. households, which could include multiple individuals in one household. Whereas population is the number of individuals in the U.S., and for ${prismProgram} this only includes adults.`
        ]
      },
      {
        id: 13,
        expanded: false,
        title: 'Households & Addresses',
        question: 'What is the difference between households and addresses?',
        description: [
          'Households are the number of U.S. households, which could include multiple individuals in one household. Whereas addresses are the number of unique U.S. addresses, which could include multiple households at one address.'
        ]
      }
    ]
  },

  'Map Information': {
    Content: [
      {
        id: 14,
        expanded: false,
        title: 'MAUP',
        question: 'What is MAUP and why does it matter?',
        description: [
          {
            subdescription: [
              "A known source of statistical bias, called the Modifiable Areal Unit Problem (MAUP), shows how the way we draw boundaries on a map can change our conclusions. For example, a statistic like population density can give you very different results depending on whether you're analyzing a small neighborhood, a zip code, or an entire county."
            ],
            points: []
          },
          {
            subdescription: [
              `For ${prismProgram} users, this means it's important to remember that every state's population is different. When you look at the number of people in a selected group, be sure to compare it to the total adult population of that state. This provides the necessary context to compare results accurately and account for this mapping effect.`
            ],
            points: []
          }
        ]
      }
    ]
  },

  'Example Use Cases': {
    Content: [
      {
        id: 15,
        expanded: false,
        title: 'Opioid Response',
        question: `How has ${prismProgram} been used for opioid response?`,
        description: [
          {
            subdescription: ['<b>Case Study: Opioid Response Analytics </b>'],
            points: []
          },
          {
            subdescription: ['<b>The Challenge</b>'],
            points: []
          },
          {
            subdescription: [
              "A Northeastern State's Department of Health and Human Services wanted to better understand the complex links between opioid use, the criminal justice system, and the effectiveness of different treatments in their communities."
            ],
            points: []
          },
          {
            subdescription: ['<b>Our Solution</b>'],
            points: []
          },
          {
            subdescription: [
              `The ${prismProgram} team analyzed data from five million people to uncover key patterns. We developed a predictive tool to identify individuals at high risk of opioid involvement and pinpointed the top 10 factors most associated with it.`
            ],
            points: []
          },
          {
            subdescription: ['<b>The Impact</b>'],
            points: []
          },
          {
            subdescription: [
              'To make these findings clear and actionable, we created interactive dashboards. These tools helped the state visualize critical information, from risk factors and treatment outcomes to geographic hot spots, empowering them to explore the data in detail and build more effective response strategies.'
            ],
            points: []
          }
        ]
      },
      {
        id: 16,
        expanded: false,
        title: 'Behavioral Analytics',
        question: `How has ${prismProgram} been used for immunization programs?`,
        description: [
          {
            subdescription: ['<b>Case Study: Behavioral Analytics to Boost Pediatric Vaccinations </b>'],
            points: []
          },
          {
            subdescription: ['<b>The Challenge</b>'],
            points: []
          },
          {
            subdescription: [
              'A Federal Health Agency wanted to increase childhood vaccination rates. They needed to find out if personalizing reminder messages for parents would be more effective than a one-size-fits-all approach.'
            ],
            points: []
          },
          {
            subdescription: ['<b>Our Solution</b>'],
            points: []
          },
          {
            subdescription: [
              `In partnership with the Agency and a State Health Department, the ${prismProgram} team analyzed public household data. We identified three distinct types of households with children and profiled the unique demographic and behavioral characteristics of each group.`
            ],
            points: []
          },
          {
            subdescription: ['<b>The Impact</b>'],
            points: []
          },
          {
            subdescription: [
              `Our analysis provided the foundation for a targeted outreach campaign. We delivered tailored messaging recommendations for each household group, allowing the agency to send personalized letters that resonated with each family's specific situation and attitudes, ultimately increasing the effectiveness of their vaccination reminders.`
            ],
            points: []
          }
        ]
      },
      {
        id: 17,
        expanded: false,
        title: 'Community Segmentation',
        question: `How was ${prismProgram} been used for COVID-19 response?`,
        description: [
          {
            subdescription: ['<b>Case Study: Community Segmentation </b>'],
            points: []
          },
          {
            subdescription: ['<b>The Challenge</b>'],
            points: []
          },
          {
            subdescription: [
              'As COVID-19 vaccination rates began to slow down in a Midwestern state, health officials needed a better way to identify and connect with citizens who were hesitant about getting vaccinated.'
            ],
            points: []
          },
          {
            subdescription: ['<b>Our Solution</b>'],
            points: []
          },
          {
            subdescription: [
              `Using machine learning and publicly available data, the ${prismProgram} team analyzed communities across the state. We identified 10 distinct community segments, each with unique factors related to vaccine hesitancy, such as income, education, and location.`
            ],
            points: []
          },
          {
            subdescription: ['<b>The Impact</b>'],
            points: []
          },
          {
            subdescription: [
              'We equipped local public health agencies with tailored outreach recommendations for each of the 10 segments. This data-driven approach allowed them to move beyond generic messaging and engage with each community in a way that was most likely to address their specific concerns and increase vaccination rates.'
            ],
            points: []
          }
        ]
      },
      {
        id: 18,
        expanded: false,
        title: 'Maternity Care Deserts',
        question: `How has ${prismProgram} been used for maternity care deserts?`,
        description: [
          {
            subdescription: ['<b>Case Study: Maternity Care Deserts Dashboard </b>'],
            points: []
          },
          {
            subdescription: ['<b>The Challenge</b>'],
            points: []
          },
          {
            subdescription: [
              'A national non-profit focused on maternal and infant health wanted to enhance their "Maternity Care Deserts" dashboard. They needed to add a deeper health and demographic dimension to better understand the disparities faced by women in areas with limited access to maternity care.'
            ],
            points: []
          },
          {
            subdescription: ['<b>Our Solution</b>'],
            points: []
          },
          {
            subdescription: [
              `The ${prismProgram} team partnered with the non-profit by providing comprehensive demographic and community health data. This information was then integrated with the non-profit's own data on maternity care access across the country.`
            ],
            points: []
          },
          {
            subdescription: ['<b>The Impact</b>'],
            points: []
          },
          {
            subdescription: [
              'By overlaying our data, the dashboard became a more powerful tool. It now provides a detailed health lens into the unique attributes of maternity care deserts, clearly highlighting the disparities that women of child-bearing age face and enabling more targeted and effective advocacy.'
            ],
            points: []
          }
        ]
      },
      {
        id: 19,
        expanded: false,
        title: 'Total Force Fitness',
        question: `How has ${prismProgram} been used for preventative health?`,
        description: [
          {
            subdescription: ['<b>Case Study: Total Force Fitness Analysis </b>'],
            points: []
          },
          {
            subdescription: ['<b>The Challenge</b>'],
            points: []
          },
          {
            subdescription: [
              'A Federal Agency needed to help its State Coordinators build healthier military communities and ensure service members were always operationally ready. To do this, coordinators required more timely and accessible data to create and refine their State Action Plans efficiently.'
            ],
            points: []
          },
          {
            subdescription: ['<b>Our Solution</b>'],
            points: []
          },
          {
            subdescription: [
              `The ${prismProgram} team provided an advanced analytics platform and a dedicated group of health experts. This gave State Coordinators a powerful tool to identify at-risk populations and understand community well-being trends with greater speed and precision.`
            ],
            points: []
          },
          {
            subdescription: ['<b>The Impact</b>'],
            points: []
          },
          {
            subdescription: [
              "The insights generated by our platform guided the focus of outreach, engagement, and collaboration efforts. This data-driven approach helped coordinators improve the readiness and resilience of active-duty military and reservists, directly supporting the agency's core mission."
            ],
            points: []
          }
        ]
      }
    ]
  },
  'Persona Feature': {
    Content: [
      {
        id: 20,
        expanded: false,
        title: 'Behavioral Personas',
        question: 'What are Behavioral Personas?',
        description: [
          {
            subdescription: [
              "Based on real data and research, U.S. population dataset is segmented into 15 distinct persona groups (or persona archetypes) based on their shared Drivers of Health (DOH) characteristics. These personas are a representation of a group or community that share similar DOH factors. This helps in understanding the target population segments or community's demographics, culture, motivations, behaviors, and challenges, to make informed outreach and messaging strategies."
            ],
            points: []
          },
          {
            subdescription: ['Here,'],
            points: [
              '<b>Persona Archetypes</b> represents a typical group of people, focusing on their core behaviors, motivations, demographics, community factors, and health drivers.',
              '<b>Behaviors</b> means their proclivity towards health care services and facilities like, hospitals, clinics medicines, vaccinations, etc. which impact their health decisions.',
              '<b>Motivations</b> means the factors that encourages them to accept modern health care services for their well-being.'
            ]
          }
        ]
      },
      {
        id: 21,
        expanded: false,
        title: 'U.S. Population Segmentation',
        question: 'How is the U.S. population segmented into different Persona archetypes?',
        description: [
          {
            subdescription: [
              'Our goal was to segment the U.S. adult population into distinct "Health Persona" groups to better understand their unique needs.'
            ],
            points: []
          },
          {
            subdescription: [
              'We began by analyzing over 80 different factors related to health, including demographics, economics, and social conditions. Using machine learning, we identified the most important factors and used them to find 15 natural groupings within representative samples of the population.'
            ],
            points: []
          },
          {
            subdescription: [
              'To apply the 15 personas to our entire database of 270 million Americans, we built a highly accurate predictive model. This model was rigorously tested for fairness and reliability, achieving 97% accuracy in assigning every individual to their correct persona group. The result is a powerful tool for creating more effective and targeted health interventions.'
            ],
            points: []
          }
        ]
      },
      {
        id: 22,
        expanded: false,
        title: 'Persona Cohorts',
        question: 'How are personas grouped into Cohorts?',
        description: [
          {
            subdescription: [
              'These 15 personas were sorted into three broader categories, which reflect their overall stability in both accessing healthcare and maintaining their well-being.'
            ],
            points: []
          },
          {
            subdescription: [
              '<b>1. Resource Constrained:</b> Populations facing social, environmental, economic, and behavioral barriers to health and well-being. Many have lower levels of educational attainment, below-average earnings, and are more likely to experience food insecurity – living in both rural and urban settings.'
            ],
            points: []
          },
          {
            subdescription: ['It includes:'],
            points: [
              '<b>American Mosaic</b> are younger, culturally connected adults who are often resourceful and tech savvy, but may face financial, housing, and health-related challenges.',
              '<b>Traditional Individualists</b> are individuals in smaller households who may face digital disconnection, limited broadband access, and elevated chronic health risks.',
              '<b>Independent Neighbors</b> are often older, lower-wage adults who value faith and cultural heritage, may live alone, and can face isolation, obesity risk, and challenges navigating care.',
              '<b>Small-Town Strivers</b> are tech-savvy, novelty-seeking individuals and families under financial pressure who may experience crowded housing, low coverage, and elevated behavioral and mental health risks.',
              '<b>Working-Class Commuters</b> are blue-collar, lower-middle-income individuals or small families who are budget-conscious, open to new things, and may face food insecurity and gaps in insurance coverage.',
              '<b>Urban Anchors</b> are community-anchored renters with strong cultural and faith ties who may face systemic barriers, lower coverage, and greater reliance on urgent or hospital-based care.',
              '<b>High Hopes</b> are smaller-household adults with above-average education who may struggle financially but are motivated, culturally curious, and often proactive about their health.'
            ]
          },

          {
            subdescription: [
              '<b>2. Moderately Resourced:</b> Members of middle-class America, spanning multiple stages of adulthood and typically falling around average for each component of the drivers of health – predominantly living in rural or suburban areas across the country.'
            ],
            points: []
          },
          {
            subdescription: ['It includes:'],
            points: [
              '<b>Stable Status Quo</b> are older, family-oriented homeowners who are politically engaged and insured but may be less inclined toward new experiences and have elevated chronic disease risk.',
              '<b>Right on Main Street</b> are middle-class, family-oriented households that are keen learners and tech savvy but often have limited discretionary income and may prefer community-based care options.',
              '<b>Middle of the Road</b> are working-class professionals who are open to new experiences, often live independently, and are generally healthy and comfortable with technology.'
            ]
          },
          {
            subdescription: [
              '<b>3. Resource Secure:</b> Individuals that are the most well-off across all drivers of health – they are both the most educated and comprise the highest earners. They typically live in more affluent areas of cities and surrounding suburbs.'
            ],
            points: []
          },
          {
            subdescription: ['It includes:'],
            points: [
              '<b>Established Residents</b> are community-engaged, high-earning households with strong family ties, homeownership, and relatively low lifestyle risks but some elevated chronic condition risks.',
              '<b>Metropolitan Comforts</b> are financially stable, family-oriented adults with strong educational attainment who are generally well resourced but may be less engaged with digital health tools.',
              '<b>Strollers and Starter Homes</b> are higher-income, family-focused homeowners who are engaged, tech savvy, and health-aware, though convenience may affect follow-through on care plans.',
              '<b>Established Empty-Nesters</b> are well-educated, financially secure households with strong access to care and healthy habits, but some elevated risk for alcohol use and chronic conditions.',
              '<b>Educated Cosmopolitans</b> are highly educated, high-earning, culturally curious adults who are tech savvy, connected, and often lifelong learners.'
            ]
          }
        ]
      }
    ]
  }
}
